<template>
  <div class="compras-abm">
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Proveedor"
          label-for="proveedor"
          :label-cols="2"
          horizontal>
          <b-input-group>
            <b-input-group-append 
                class="filter-search-icons" 
                @click="seleccionarProveedor">
              <b-input-group-text>
                <i class="fa fa-search"></i>
              </b-input-group-text>
            </b-input-group-append>
            <b-form-input 
              id="proveedor"
              :value="proveedorNombre"
              readonly
              type="text"/>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Fecha Comp."
          label-for="fechaComprobante"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="fechaComprobante" 
            v-model= "fechaComprobante" 
            type="date">
          </b-form-input>
        </b-form-group>

        <div class="grupo-controles">
          <b-form-group
            label="Número"
            label-for="numero"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="numeroPuntoVenta"
              v-model.number= "numeroPuntoVenta" 
              :state="numeroPuntoVentaValido"
              type="number"
              min="0000" max="9999">
            </b-form-input>
            <b-form-input 
              id="numero"
              v-model.number= "numero" 
              :state="numeroValido"
              type="number">
            </b-form-input>
            <b-form-invalid-feedback id="numeroFeedback">
              Verifique el número de comprobante ingresado
            </b-form-invalid-feedback>          
          </b-form-group>
        </div>

        <b-form-group
          label="Monto Total"
          label-for="montoTotal"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="montoTotal"
            v-model= "montoTotal" 
            :state="montoTotalValido"
            type="text">
          </b-form-input>
          <b-form-invalid-feedback id="montoTotalFeedback">
            Ingrese el monto del comprobante
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-form>

      <div slot="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="update">Grabar</b-button>
          <b-button size="sm" variant="danger" class="footer-button"
            @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue'
import moment from 'moment';

export default {
  components: {
    appSearchProveedor: SearchProveedor,
  },
  props: {
    viaticoId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      proveedor: null,
      proveedorNombre: null,
      fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
      montoTotal: 0,
      numero: 0,
      numeroPuntoVenta: 0,

      montoTotalValido: null,
      numeroValido: null,
      numeroPuntoVentaValido: null,
    }
  },
  created() {
  },  
  methods: {

    update() {
      let compraParams = {
        proveedorId: this.proveedor.id,
        fecha: this.fechaComprobante,
        numeroPuntoVenta: this.numeroPuntoVenta,
        numero: this.numero,
        total: this.montoTotal,
        viaticoId: this.viaticoId
      }
      this.$store.dispatch('compra/setCompraParametros', compraParams)
        .then(() => {
          this.$emit('closeCompraDatos');
        })
    },

    seleccionarProveedor() {
      this.$refs.searchProveedorModal.show()
    },
    proveedorSeleccionado(item) {
      this.proveedor = item;
      this.proveedorNombre = item? item.nombre.trim() : null;
      this.$refs.searchProveedorModal.hide();
    },
    close() {
      this.$emit('closeCompraDatos')
    },
  },
  watch: {
  }    
}
</script>

<style>
</style>
